import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import _flatten from 'lodash/flatten';

// Context
import { useCompareContext } from '@/context/compare';

// Components
import CompareTableHead from '@/braun/components/molecules/CompareTableHead';
import CompareTableBody from '@/braun/components/molecules/CompareTableBody';

const CompareTable = () => {
  const [{ compareData, productsCode }] = useCompareContext();
  const { results } = compareData;

  if (_isEmpty(results)) return null;

  // Creating a Flat Array of Title strings
  const featureTitles = _flatten(
    Object.keys(results).map(featureGroup =>
      Object.keys(results[featureGroup]),
    ),
  );

  // Creating an array of arrays of Feature values,
  // each array corresponds to the product
  const featureValues = productsCode.map(product =>
    _flatten(
      Object.keys(results).map(featureGroup =>
        Object.keys(results[featureGroup]).map(
          feature => results[featureGroup][feature][product],
        ),
      ),
    ),
  );

  return (
    <div className='bra-compareTray__table'>
      <table className='bra-comparsionTable'>
        {featureTitles.length > 0 && (
          <>
            <CompareTableHead titles={featureTitles} />
            <CompareTableBody
              featureValues={featureValues}
              titles={featureTitles}
            />
          </>
        )}
      </table>
    </div>
  );
};

export default CompareTable;
